import { render, staticRenderFns } from "./Shell.vue?vue&type=template&id=2d8396dc&scoped=true"
import script from "./Shell.vue?vue&type=script&lang=js"
export * from "./Shell.vue?vue&type=script&lang=js"
import style0 from "./Shell.vue?vue&type=style&index=0&id=2d8396dc&prod&lang=css"
import style1 from "./Shell.vue?vue&type=style&index=1&id=2d8396dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8396dc",
  null
  
)

export default component.exports